<script setup lang="ts">
import { useToast } from '@/composables/useToast';
import { XIcon } from 'lucide-vue-next';

const { toasts, removeToast } = useToast();

async function handleAction({ id, onAction }: { id: string, onAction?: () => void | Promise<void> }) {
  if (onAction) {
    await onAction();
  }
  removeToast({ id, reason: 'action' });
}


defineExpose({
  ...((__BUILD_MODE_IS_TEST__ && {
    TEST_ONLY: {
      // Export internal state and logic used only for testing here. Do not reference these in production logic.
    },
  }) || {}),
});

import "virtual:naidan-tailwind-css-module/3167eb4d3f7a412b2485bf77e9ada08ef1e83e852e9e99fc47d4683dc762490f.js";
import "virtual:naidan-tailwind-css-module/38ddc67182078de9cb932ed083d7a1455eaffe85410676015e4a7f0e622ff047.js";
</script>

<template>
  <div tw-class="fixed bottom-6 right-6 z-[250] flex flex-col gap-3 pointer-events-none">
    <TransitionGroup name="toast">
      <div
        v-for="toast in toasts"
        :key="toast.id"
        tw-class="pointer-events-auto flex items-center gap-4 bg-gray-900 dark:bg-gray-800 text-white px-4 py-3 rounded-lg shadow-2xl border border-gray-700 min-w-[300px] max-w-md"
      >
        <span tw-class="text-sm flex-1">{{ toast.message }}</span>

        <button
          v-if="toast.actionLabel"
          @click="handleAction({ id: toast.id, onAction: toast.onAction })"
          tw-class="text-indigo-400 hover:text-indigo-300 text-xs font-bold uppercase tracking-wider px-2 py-1"
        >
          {{ toast.actionLabel }}
        </button>

        <button
          @click="removeToast({ id: toast.id, reason: 'dismiss' })"
          tw-class="text-gray-500 hover:text-gray-300 transition-colors"
        >
          <XIcon tw-class="w-4 h-4" />
        </button>
      </div>
    </TransitionGroup>
  </div>
</template>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.toast-enter-from {
  opacity: 0;
  transform: translateY(20px) scale(0.9);
}

.toast-leave-to {
  opacity: 0;
  transform: translateX(20px);
}

.toast-move {
  transition: transform 0.3s ease;
}
</style>
